<template>
  <v-col class="pt-0 pb-0">
    <v-layout>
      <p class="pt-2">{{ getUserNameOrEmail(user) }} - {{ getTextForOrganization(user.organizationName) }}</p>
      <v-btn v-if="!organizationEditable" class="ml-3" text icon color="primary" @click="organizationEditable = true">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
      <v-btn v-if="organizationEditable && canDelete" class="ml-3" text icon color="primary" @click="deleteUser">
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </v-layout>
    <v-layout v-if="organizationEditable">
      <v-flex xs9 sm7 md5 lg4>
        <v-select color="primary" outlined :items="organizations" label="Select organization" v-model="selectedOrganization"/>
      </v-flex>
      <v-btn class="pt-5 pb-8 pl-8 pr-8 ml-3" dark color="primary" @click="updateOrganization(selectedOrganization)">
        <p>Save</p>
      </v-btn>
    </v-layout>
  </v-col>
</template>
<script>

export default {
  props: ['user', 'organizations', 'canDelete'],
  data () {
    return {
      organizationEditable: false,
      selectedOrganization: '',
      organizationOptions: [],
      NONE: 'None' // be able to remove access to a user without deleting it
    }
  },
  methods: {
    updateOrganization (organization) {
      this.organizationEditable = false
      if (organization === this.NONE) {
        this.selectedOrganization = ''
      }
      let newUser = Object.assign({ organizationName: this.selectedOrganization }, this.user)
      newUser.organizationName = this.selectedOrganization
      this.$emit('updateOrgainzationForUser', newUser)
    },
    deleteUser () {
      this.$emit('deleteUser', this.user)
    },
    getUserNameOrEmail (user) {
      return typeof user.name === 'undefined' || user.name === '' ? user.email : user.name
    },
    getTextForOrganization (org) {
      return typeof org === 'undefined' || org === '' ? 'Not assigned to any organization' : `signed into ${org} organization`
    }
  },
  async created () {
    this.organizationOptions = this.organizations
    this.organizationOptions.push(this.NONE)
  }
}
</script>
